import { useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom'
import Breadcrumbs from '../../../global/Components/Breadcrumb/Breadcrumb';
import { Form, Row, Col,
   FormGroup, Input, Label, FormFeedback, FormText,Spinner, Accordion, AccordionItem, AccordionHeader, AccordionBody, Button } from 'reactstrap';
import TooltipElement from '../../../global/Components/Tooltip/TooltipElement';
import styles from "./EditProduct.module.scss";
import { useOnChangeHandler } from '../../../global/utils/hooks/useOnChangeHandler';
import Regions from '../../../global/Components/Regions/Regions';
import SelectForm from '../../../global/Components/Items/SelectForm/SelectForm';
import { useEffect } from 'react';
import useApiPrivate from '../../../global/utils/hooks/useApiPrivate';
import { getRequest } from '../../../global/utils/apiCall';
import ImageCard from '../../../global/Components/Items/ImageCard/ImageCard';
import Upload from '../../../global/Components/Upload/Upload';
import { Editor } from 'primereact/editor'
import { Toast } from 'primereact/toast';

const PRODUCTS_URL = 'api/v1/products/';
const CATEGORY_FILTERS = 'api/v1/categories/';
const EDIT_PRODUCT_URL = 'api/v1/products/edit';

export default function EditProduct() {
    const {id} = useParams();
    const apiPrivate = useApiPrivate();
    const navigate = useNavigate();
    const toast = useRef(null);


    const [selectCategoryId,setSelectCategoryId] = useState('');
    const [selectCategoryName,setSelectCategoryName] = useState('');

    const [isValid, setIsValid] =useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [open, setOpen] = useState('1');

    const [categoryFilters,setCategoryFiltars] = useState([]);
    const [productProperties, setProductProperties] = useState([]);
    const [country, setCountry] = useState('');
    const [state, setState] = useState('');
    const [city, setCity] = useState('');
    const [product, setProduct] = useState('');
  
    
    const [productStatus, setProductStatus, onChangeHandlerProductStatus] = useOnChangeHandler('');
    const [productName, setProductName, onChangeHandlerProductName] = useOnChangeHandler('');
    const [productDescription, setProductDescription, onChangeHandlerProductDescription] = useOnChangeHandler('');
    const [productPrice, setProductPrice, onChangeHandlerProductPrice] = useOnChangeHandler('');
    const [productDiscount, setProductDiscount, onChangeHandlerProductDiscount] = useOnChangeHandler('');
    const [image, setImage, onChangeHandlerImage] = useOnChangeHandler({src:'', newImages:''});
    const [galleries, setGalleries, onChangeHandlerGalleries] = useOnChangeHandler({src: [], newImage: []});
    const [productTags, setProductTags, onChangeHandlerProductTags] = useOnChangeHandler([]);

    const toggle = (id) => {
      if (open === id) {
        setOpen('');
      } else {
        setOpen(id);
      }
    };

  const showSuccess = (message) => {
    toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
  }
  const showError = (message) => {
    toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
  }

    const handleImage = (file) => {
      setImage({...image, newImage:file});
    }

    const handleImages = (file) => {
      setGalleries({...galleries, newImages: file});
    }

    const callProduct = async () => {
      setIsLoading(true);

      try {
        const response = await apiPrivate.get(`${PRODUCTS_URL}${id}`,{
          params:{
            seller: 1,
          }  
        }
        )
        let product = response.data.data;
        setProduct(product)
        setSelectCategoryId(product.category_id);
        setSelectCategoryName(product.category.title)
        setProductStatus(product.product_status);
        setProductName(product.title);
        setProductPrice(product.price);
        setProductDiscount(product.discount);
        setProductDescription(product.description);
        setProductTags(String(product.tags));
        setProductProperties(product.properties);
        setCountry(product.country_id)
        setProductProperties(product.properties);
        setImage({...image, src:product.image});
        setGalleries({...galleries, src: product.galleries});
        setIsLoading(false);
      }
      catch (error) {
        if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
          showError(error?.response?.data?.message)
        } 
        setIsLoading(false);
      }
      finally {
        setIsLoading(false);
      }

    }
    const renderHeader = () => {
      return (
        <span className="ql-formats">
          <button className="ql-bold" aria-label="Bold"></button>
          <button className="ql-italic" aria-label="Italic"></button>
          <button className="ql-underline" aria-label="Underline"></button>
          <select className="ql-align" defaultValue={'left'}>
            <option></option>
            <option value="right"></option>
            <option value="center"></option>
          </select> 
          <button className="ql-list" value="ordered"></button>
          <button className="ql-list" value="bullet"></button>                         
        </span>
      );
  };

  const header = renderHeader();

    const callCategoryFilters = async () => {
      setIsLoading(true);

      try{
        const response = await getRequest(`${CATEGORY_FILTERS}${selectCategoryId}/filters`);
        setIsLoading(false);
        setCategoryFiltars(response.data.data);
      } catch (error) {
        if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
          showError(error?.response?.data?.message); 
        } 
        setIsLoading(false);
      }
    }

    const handleBlur = (e) => {
      if (e.target.value === '') {
        e.target.classList.add("is-invalid");
      } else {
        e.target.classList.remove("is-invalid");
      }
    };
    
    const handleFocus = (e) => {
      e.target.classList.remove("is-invalid");
      setIsValid(false); 
    }
    
    const handleSelectRegions = (selected) => {
      setCountry(selected['country_id']);
      setState(selected['state_id']);
      setCity(selected['city_id']);
    }

    const handleSelectOption = (selectedId, selectOptionId) => {
      let sldId = parseInt(selectedId);
      let selectedOptionId = parseInt(selectOptionId);

      if (productProperties.length < 1) {
        setProductProperties([...productProperties,{property_id: sldId, property_item_id: selectedOptionId}]);
        return
      }

      var resualt = productProperties.find((element) => element.property_id === sldId);

      for (var item of productProperties) {

        if (resualt === undefined){
          setProductProperties([...productProperties,{property_id: sldId, property_item_id: selectedOptionId}]);    
          
        } else {
            setProductProperties(prevState => {
              const newState = prevState.map(resualt => {
                if(resualt.property_id === sldId){
                  return {...resualt, property_item_id: selectedOptionId}
                }
                return resualt;
              });
              return newState;
            })
        }
      }
    }

    const editProduct = async () => {
      setIsLoading(true);

      const formData = new FormData();

      let tagArray = [];

      formData.append('id', id);
      formData.append('category_id', selectCategoryId);
      formData.append('product_status', productStatus);
      formData.append('title', productName);
      formData.append('price', productPrice);
      formData.append('discount', productDiscount ? productDiscount : '');
      formData.append('description', productDescription || '');
      formData.append('country_id', country ? country : '');
      formData.append('state_id', state ? state : '' );
      formData.append('city_id', city ? city : '');

      if(productTags.length > 0) {
        tagArray = productTags.split(',');       

        for (let i = 0 ; i < tagArray.length ; i++ ) {
          formData.append(`tags[${i}]`,tagArray[i]);
        } 
      }
      formData.append('image', image.newImage[0] ? image.newImage[0] : '');

      for (let i = 0 ; i < productProperties.length ; i++) {
        formData.append(`properties[${i}][property_id]`,productProperties[i].property_id);
        formData.append(`properties[${i}][property_item_id]`,productProperties[i].property_item_id);
      }

      try {
        const response = await apiPrivate.post(EDIT_PRODUCT_URL,formData,{
          headers: {
              'content-type': 'multipart/form-data',  
          }}
          )
          setIsLoading(false);
          showSuccess('Edit product successfully')
          setTimeout(() => {
            navigate('/dashboard/my-products');
          }, 3000);
      }
      catch (error) {
        if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
          showError(error?.response?.data?.message)
        } 
      }
      finally {
        setIsLoading(false);
      }
    }

    useEffect(() => {
      callProduct();
    },[]);

  useEffect(() => {
    selectCategoryId &&
      callCategoryFilters();
  },[selectCategoryId]); 

  return (
    <div>
        <Breadcrumbs />
        <Toast ref={toast} position="top-center" />

        <div className={`fw-bold mb-3`}>
            Edit: {productName}
        </div>
        {
          isLoading 
            ? (
              <>
                <Spinner color='primary' className='mx-auto'>
                  Loading...
                </Spinner>
              </>
            ) 
            : (
              <Accordion open={open} toggle={toggle} className='mb-3'>
                <AccordionItem>
                  <AccordionHeader targetId="1">
                    <i className='bi bi-card-list me-2 big text-primary'></i>
                    <span className='fw-bold'> 
                      Product info
                    </span>
                  </AccordionHeader>
                  <AccordionBody accordionId="1">
                    <Form id='editForm' onSubmit={editProduct}>
                      <Row>
                        <Col sm={12} md={6}> 
                            <FormGroup floating>
                              <Input
                                id="search-category"
                                name="category_id"
                                value={selectCategoryName}
                                placeholder="Search"
                                onChange={setSelectCategoryId}
                                type="text"
                                disabled
                              />
                              <Label for="search-category">
                                Category
                              </Label>
                              <FormText>
                                Category cannot be changed
                              </FormText>
                            </FormGroup>   
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={12} md={6}>
                          <FormGroup floating>
                            <Input
                              id="product-name"
                              name="title"
                              placeholder="Product name"
                              type="text"
                              value={productName}
                              onChange={onChangeHandlerProductName}
                              required
                              onFocus={handleFocus}
                              onBlur={handleBlur}
                              invalid={isValid}
                            />
                            <FormFeedback tooltip>
                              The product name must be at least 3 letters long
                            </FormFeedback>
                            <span className={`${styles.infoIcon}`}
                                  rel="noreferrer"
                                  id="product-name">
                              <i className={`bi bi-info-circle`}  id='product-name-desc'></i>
                            </span>
                            <TooltipElement target={'product-name-desc'}>
                              Brand and product name
                            </TooltipElement>
                            <Label for="product-name">
                              Product name
                              <span className='text-danger'>*</span>
                            </Label>
                          </FormGroup>    
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <div className='mb-3'>
                            <Label className='d-block mb-2 fw-semibold'>
                              Status
                            <span className='text-danger'>*</span></Label>
                            <Input
                              type="radio"
                              name="product_status"
                              value="new"
                              className={`invisible ${styles.removeRadio}`}
                              id="new"
                              checked={productStatus === "new"}
                              onChange={onChangeHandlerProductStatus}
                              required
                              onFocus={handleFocus}
                              onBlur={handleBlur}
                              invalid={isValid}
                            />
                            <FormFeedback tooltip>
                              This field is required                            
                            </FormFeedback>
                            <Label 
                                htmlFor="new"
                                className={`outlinBtn ms-2 p-1 ${productStatus == "new" ? 'active' : ''}`}
                                >
                                  New
                                </Label>

                            <Input
                              type="radio"
                              name="product_status"
                              value="old"
                              className={`invisible ${styles.removeRadio}`}
                              id="old"
                              checked={productStatus === "old"}
                              onChange={onChangeHandlerProductStatus}
                            />
                            <Label 
                                htmlFor="old"
                                className={`outlinBtn ms-2 p-1 ${productStatus == "old" ? 'active' : ''}`}
                                >
                                  Old
                                </Label>
                            <Input
                              type="radio"
                              name="product_status"
                              value="defective"
                              className={`invisible ${styles.removeRadio}`}
                              id="defective"
                              checked={productStatus === "defective"}
                              onChange={onChangeHandlerProductStatus}
                            />
                            <Label 
                              htmlFor="defective"
                              className={`outlinBtn ms-2 p-1 ${productStatus == "defective" ? 'active' : ''}`}
                              >
                                Defective
                              </Label>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={4}>
                          <FormGroup floating>
                            <Input
                              id="product-price"
                              name="price"
                              placeholder="Product price"
                              type="text"
                              value={productPrice}
                              onChange={onChangeHandlerProductPrice}
                              required
                              onFocus={handleFocus}
                              onBlur={handleBlur}
                              invalid={isValid}
                            />
                            <FormFeedback tooltip>
                              This field is required                            
                            </FormFeedback>
                            <span 
                              className={`${styles.infoIcon}`}
                              rel="noreferrer"
                              id="product-price">
                              <i className={`bi bi-info-circle`}  id='product-price-desc'></i>
                            </span>
                            <TooltipElement target={'product-price-desc'}>
                              Product price
                            </TooltipElement>
                            <Label for="product-price">
                              Price
                            </Label>
                          </FormGroup>  
                        </Col>
                        <Col md={4}>
                          <FormGroup floating>
                            <Input
                              id="product-discount"
                              name="discount"
                              placeholder="Product discount"
                              type="text"
                              value={productDiscount ? productDiscount : ''}
                              onChange={onChangeHandlerProductDiscount}
                            />
                            <span 
                              className={`${styles.infoIcon}`}
                              rel="noreferrer"
                              id="product-discount">
                              <i className={`bi bi-info-circle`}  id='product-discount-desc'></i>
                            </span>
                            <TooltipElement target={'product-discount-desc'}>
                              Discount percent
                            </TooltipElement>
                            <Label for="product-discount">
                              Discount
                            </Label>
                          </FormGroup>  
                        </Col>
                      </Row>
                      <Row>
                      <Col md={6}>
                          <FormGroup floating>
                            <Input
                              id="product-tags"
                              name="tags"
                              placeholder="Product tags"
                              type="text"
                              value={productTags}
                              onChange={onChangeHandlerProductTags}
                              required
                              onFocus={handleFocus}
                              onBlur={handleBlur}
                              invalid={isValid}
                            />
                            <FormFeedback tooltip>
                              This field is required                            
                            </FormFeedback>
                            <span className={`${styles.infoIcon}`}
                                  rel="noreferrer"
                                  id="product-tags">
                              <i className={`bi bi-info-circle`}  id='product-tags-desc'></i>
                            </span>
                            <TooltipElement target={'product-tags-desc'}>
                              Product tags
                            </TooltipElement>
                            <Label for="product-tags">
                              Tags
                              <span className='text-danger'>*</span>
                            </Label>
                          </FormGroup>  
                        </Col>
                      </Row>
                      <FormGroup>
                        <Row>
                            <Regions col={4} handleSelectRegions={handleSelectRegions} countryId={product.country_id} stateId={product.state_id} cityId={product.city_id} />
                        </Row>
                      </FormGroup>
                      <Row>
                        <Col md={12}>
                          <FormGroup>
                            <Label className='fw-semibold' for="uploadImage">
                              Product Image
                            </Label>
                          </FormGroup>
                          <img 
                            src={`${!image.src ? '/images.png' : `${process.env.REACT_APP_API_URL}${image.src}`}`}
                            alt="product image"
                            className={`img-fluid img-thumbnail w-50 mb-3`}
                            />
                            <FormGroup>
                            <Upload 
                              id="uploadImage"
                              name="image"
                              accept="image/jpeg, image/png, image/jpg, image/jpe"
                              outSideRequest={true}
                              productId={id}
                              multiple={false} 
                              handleImages={handleImage}
                              callProduct={callProduct}/>
                             <FormText>
                              Accept Format: .jpeg, .jpg, jpe, .png
                             </FormText>
                            <FormFeedback>
                              This field is required                            
                            </FormFeedback>
                          </FormGroup>
                        </Col>
                      </Row>
                      <FormGroup>
                        <Label className='d-block mb-2 fw-semibold'>
                          Product Features
                        </Label>
                        <Row>
                        {
                          categoryFilters.map((filter) => (
                            <Col md={3} className='mb-3' key={filter.id}>
                              <div>
                                <Label className='fw-semibold'>
                                  {filter.title}
                                  {
                                    filter.is_force 
                                    ? <span className='text-danger'>*</span>
                                    : ''
                                  }
                                </Label>
                              </div>
                              <div>
                                <SelectForm 
                                  onFocus={handleFocus}
                                  onBlur={handleBlur}
                                  invalid={isValid} 
                                  handleSelectOption={handleSelectOption} 
                                  data={filter}
                                  properties={productProperties}/>
                              </div>
                            </Col>
                          ))
                        }
                        </Row>
                      </FormGroup>
                      <Row>
                        <Col md={12}>
                          <FormGroup>
                          <Label className='d-block mb-2 fw-semibold'>
                              More Details
                          </Label>
                          <Editor 
                            id='more-details' 
                            name='description' 
                            value={productDescription} 
                            onTextChange={(e) => setProductDescription(e.htmlValue)} 
                            style={{ height: '320px', color: '#212529',size: '16px' }} 
                            headerTemplate={header} />
                            <FormText>
                              Avoid entering contact information such as: phone, email and address.
                            </FormText>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Button
                              type='submit'
                              disabled={!productName || !productStatus || !productPrice || !image && true}>
                            Save
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </AccordionBody>
                </AccordionItem>
                <AccordionItem>
                  <AccordionHeader targetId="2">
                    <i className='bi bi-images me-2 big text-primary'></i>
                    <span className='fw-bold'>
                      Product Galleries
                    </span>
                  </AccordionHeader>
                  <AccordionBody accordionId="2">
                      <Form>
                        <FormGroup>
                          <Row>
                            <Col md={12}>
                              <ImageCard galleries={galleries.src} />
                              <FormGroup>
                                <Label className='fw-semibold' for="uploadImages">
                                  Galleries
                                  <span className='text-danger'>*</span>
                                </Label>
                              </FormGroup>
                            </Col>
                            <Col md={12}> 
                              <FormGroup>
                                <Upload  
                                  id="uploadImages"
                                  name="image"
                                  accept="image/jpeg, image/png, image/jpg, image/jpe"
                                  required={true}
                                  handleImages={handleImages}
                                  productId={id} 
                                  multiple={true} 
                                  isUploadButton={true}
                                  callProduct={callProduct}/>
                                <FormText>
                                  Accept Format: .jpeg, .jpg, jpe, .png
                                </FormText>
                                <FormFeedback>
                                  This field is required                            
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                          </Row>
                        </FormGroup>
                      </Form>
                  </AccordionBody>
                </AccordionItem>
              </Accordion>
            )
        }
    </div>
  )
}
